(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    const sections = document.querySelectorAll('.parallax-story');
    if (!sections.length) return;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const lerp = (start, end, amount) => start + (end - start) * amount;
    const smoothstep = (value) => {
      const t = clamp(value, 0, 1);
      return t * t * (3 - 2 * t);
    };
    const segmentProgress = (value, start, end) => smoothstep((value - start) / (end - start));

    const updateProgress = (section) => {
      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      const scrollable = Math.max(1, rect.height - viewportHeight);
      const progress = clamp((-rect.top) / scrollable, 0, 1);
      const eased = smoothstep(progress);
      const strength = parseFloat(getComputedStyle(section).getPropertyValue('--parallax-strength')) || 360;
      const cardOneProgress = segmentProgress(progress, 0.02, 0.62);
      const cardTwoProgress = segmentProgress(progress, 0.44, 1);
      const cardOneStart = viewportHeight * 1.24 + strength * 0.34;
      const cardOneEnd = viewportHeight * -1.26 - strength * 0.28;
      const cardTwoStart = viewportHeight * 1.5 + strength * 0.5;
      const cardTwoEnd = viewportHeight * -1.34 - strength * 0.32;
      const cardOneY = lerp(cardOneStart, cardOneEnd, cardOneProgress);
      const cardTwoY = lerp(cardTwoStart, cardTwoEnd, cardTwoProgress);
      const cardOneScale = lerp(0.96, 1.02, cardOneProgress);
      const cardTwoScale = lerp(0.94, 1, cardTwoProgress);
      const cueProgress = segmentProgress(progress, 0.96, 1);
      const cueOpacity = 1 - cueProgress;
      const cueY = lerp(0, 24, cueProgress);

      section.style.setProperty('--parallax-progress', eased.toFixed(4));
      section.style.setProperty('--parallax-card-1-y', `${cardOneY.toFixed(2)}px`);
      section.style.setProperty('--parallax-card-2-y', `${cardTwoY.toFixed(2)}px`);
      section.style.setProperty('--parallax-card-1-scale', cardOneScale.toFixed(4));
      section.style.setProperty('--parallax-card-2-scale', cardTwoScale.toFixed(4));
      section.style.setProperty('--parallax-cue-opacity', cueOpacity.toFixed(4));
      section.style.setProperty('--parallax-cue-y', `${cueY.toFixed(2)}px`);
    };

    const visibleSections = new Set();
    let rafId = null;

    const tick = () => {
      rafId = null;
      visibleSections.forEach((section) => updateProgress(section));
    };

    const requestTick = () => {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleSections.add(entry.target);
            updateProgress(entry.target);
          } else {
            visibleSections.delete(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '20% 0px 20% 0px',
        threshold: [0, 0.15, 0.3, 0.5, 0.8, 1]
      }
    );

    sections.forEach((section) => {
      observer.observe(section);
      updateProgress(section);
    });

    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
